// extracted by mini-css-extract-plugin
export default {"container":"Cliente_container__lq8AL","link":"Cliente_link__YPg8u"};